<div class="kt-mat-snackbar">
  <div class="kt-mat-snackbar__message">{{ data.message }}</div>
  <div class="kt-mat-snackbar__btn">
    @if (data.showUndoButton) {
      <button
        type="button"
        mat-button
        color="primary"
        (click)="onDismissWithAction()"
      >
        Undo
      </button>
    }
  </div>
  <div class="kt-mat-snackbar__close">
    @if (data.showCloseButton) {
      <button mat-icon-button (click)="onDismiss()" color="warn">
        <mat-icon>clear</mat-icon>
      </button>
    }
  </div>
</div>
